module.exports = __webpack_public_path__ + "img/MS_WeaponSword003.abe89f6f.png";